import { useState } from 'react';
import { FaMoneyBillWave } from "react-icons/fa";

export default function PaymentMethod({ onPaymentMethodChange }) {
    const [paymentType, setPaymentType] = useState("");

    const handleChange = (e) => {
        const value = e.target.value;
        setPaymentType(value);
        onPaymentMethodChange(value);
    };

    return (
        <div className="payment-method-section">
            <div className="payment-selector">
                <h3 className="payment-title">طريقة الدفع</h3>
                <select
                    value={paymentType}
                    onChange={handleChange}
                    className="payment-type-select"
                    required
                >
                    <option value="">أختر طريقة الدفع</option>
                    <option value="Cash">كاش</option>
                </select>
                {paymentType === "Cash" && (
                    <FaMoneyBillWave className="cash-icon" />
                )}
            </div>
        </div>
    );
}